import { ProgramId } from 'modules/program';

import { IBranding, searchWidgetConfig } from 'features/search-widget';

interface IGetBrandingConfigOptions {
  programId: ProgramId;
}

function getBrandingConfig({ programId }: IGetBrandingConfigOptions): IBranding {
  const { branding } = searchWidgetConfig[programId];

  return branding;
}

export { getBrandingConfig };
